const NoInternet = () => {
  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="text-center">
        {/* Modern No Internet SVG */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="120"
          height="120"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#ff4d4d"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M2 16.5a10 10 0 0 1 20 0" />
          <path d="M4.9 12.5a7 7 0 0 1 14.2 0" />
          <path d="M7.9 8.5a4 4 0 0 1 8.2 0" />
          <line x1="12" y1="20" x2="12" y2="20" />
          <line x1="2" y1="2" x2="22" y2="22" stroke="red" strokeWidth="2" />
        </svg>

        <h1 className="text-danger mt-3">No Internet</h1>
        <p className="text-muted">
          Please check your network connection and try again.
        </p>
      </div>
    </div>
  );
};

export default NoInternet;

// import React from 'react';

// const NoInternet = () => {
//     return (
//         <div className="container d-flex justify-content-center align-items-center vh-100">
//             <div className="text-center">
//             <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         width="100"
//                         height="100"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="red"
//                         strokeWidth="2"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                     >
//                         <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3l-8.47-14.14a2 2 0 0 0-3.42 0z" />
//                         <line x1="12" y1="9" x2="12" y2="13" />
//                         <line x1="12" y1="17" x2="12" y2="17" />
//                     </svg>
//                 <h1 className="text-danger">No Internet</h1>
//                 <p className="text-muted">Please check your network connection and try again.</p>

//             </div>
//         </div>
//     )
// }

// export default NoInternet
